module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Crowdfunding"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-size-5"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("💰 Crowdfunding")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("🤔 Through crowdfunding we would like to do Progressbar Improvement Fund")]), _vm._v(" "), _c('p', [_vm._v("🥰 Progressbar is giving space to numerous meetups for free (150+meetups/year), but we need to pay for rent.\n              Our cashflow now covers ⅔ of rent from cowork, rest is from meetups.")]), _vm._v(" "), _c('p', [_vm._v("😱 We are missing resources for improvements in space to have quality space.")]), _vm._v(" "), _c('p', [_vm._v("💪 For continuous improvements we need continuous funding to have better place and fix broken things.")]), _vm._v(" "), _c('p', [_vm._v("🙄 We often miss money for daily maintenance.")]), _vm._v(" "), _c('p', [_vm._v("Things we'd like get funds for:")]), _vm._v(" "), _c('p', [_vm._v("📽 .8k€ - New projector 1080p to have vivid colours and better picture during meetups")]), _vm._v(" "), _c('p', [_vm._v("🌬 .5€ - Air ventilation in meeting room")]), _vm._v(" "), _c('p', [_vm._v("🍛 .3k€ - Dishwasher - we have daily over 40 dirty 🥛")]), _vm._v(" "), _c('p', [_vm._v("🪑 .4k€ - New chairs to meeting room - our actuall chairs getting wonky")]), _vm._v(" "), _c('p', [_vm._v("🎥 1k€+ - Livestreaming equipment (Mevo, Capture card)")]), _vm._v(" "), _c('p', [_vm._v("🎤 .6k€ - Mixpult and 4 channel microphones - quality sound input on livestreams")]), _vm._v(" "), _c('p', [_vm._v("🧼 .1k€ - Hygienic dispensor to toilet - less unwanted bacteries on your hands")]), _vm._v(" "), _c('p', [_vm._v("♨️ .2k€ - Water heater to the kitchen - sometimes we wash things manually in hands")]), _vm._v(" "), _c('p', [_vm._v("🔇 1k3€ - Soundproofing of space for comfort during day stay")]), _vm._v(" "), _c('p', [_vm._v("📺 1k€ - Television on wheel for workshops")]), _vm._v(" "), _c('p', [_vm._v("📱 .3k€ - Phone for showing bookings on meeting room")]), _vm._v(" "), _c('p', [_vm._v("💬 5k€ - Another meeting room")]), _vm._v(" "), _c('h1', [_c('router-link', {
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("\n                To support our case, you can directly support us via donations\n              ")])], 1), _vm._v(" "), _vm._m(1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-vertical is-4"
  }, [_c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent is-vertical"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/crowdfunding/crowdfunding.jpg",
      "alt": "crowdfunding"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('a', {
    attrs: {
      "href": "https://www.alza.sk/nakupni-seznamy.htm?sharelist=7665686D676E697F7"
    }
  }, [_vm._v("List to Alza.sk (local Amazon) for things we need")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ed72b31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Crowdfunding.vue
// module id = 239
// module chunks = 3